module.exports = __webpack_public_path__ + "media/images/icons/icons_small/21_presentbag-a2a8c384f287ee0c3872bcc70da48779.png";